import { http } from './http'
import {
  ICurrency,
  IGroup,
  IGroupCurrencyDetails,
  IGroupFestival,
  IGroupFestivalPayload,
  PaymentProvider,
} from '../../common/models/groups'

export const getGroups = () => http.get<IGroup[]>('/operations/festival-groups')

export const updateGroup = (id: string, name: string) =>
  http.put<IGroup>(`/operations/festival-groups/${id}`, { name })

export const createGroup = (name: string) =>
  http.post<IGroup>(`/operations/festival-groups`, { name })

export const deleteGroup = (id: string) =>
  http.delete<IGroup>(`/operations/festival-groups/${id}`)

export const updateGroupFestival = (
  festivalGroupId: string,
  festivalId: string,
  data: IGroupFestivalPayload,
) =>
  http.put<IGroupFestival>(
    `/operations/festival-groups/${festivalGroupId}/festivals/${festivalId}`,
    data,
  )

export const deleteGroupFestival = (
  festivalGroupId: string,
  festivalId: string,
) =>
  http.delete<IGroupFestival>(
    `/operations/festival-groups/${festivalGroupId}/festivals/${festivalId}`,
  )

export const updateGroupCurrency = (
  festivalGroupId: string,
  currencyId: string,
  data: ICurrency,
) =>
  http.put<ICurrency>(
    `/operations/festival-groups/${festivalGroupId}/currencies/${currencyId}`,
    data,
  )

export const deleteGroupCurrency = (
  festivalGroupId: string,
  currencyId: string,
) =>
  http.delete<ICurrency>(
    `/operations/festival-groups/${festivalGroupId}/currencies/${currencyId}`,
  )

export const updateGroupCurrencyDetails = (
  festivalGroupId: string,
  data: IGroupCurrencyDetails[],
) =>
  http.put<ICurrency>(
    `/operations/festival-groups/${festivalGroupId}/currencies/details`,
    data,
  )

export const createGroupCurrency = (
  festivalGroupId: string,
  data: Omit<ICurrency, 'id'>,
) =>
  http.post<ICurrency>(
    `/operations/festival-groups/${festivalGroupId}/currencies`,
    data,
  )

export const getPaymentProviders = () =>
  http.get<PaymentProvider[]>('/operations/payment-providers')

export const createPaymentProvider = (data: Omit<PaymentProvider, 'id'>) =>
  http.post<PaymentProvider[]>('/operations/payment-providers', data)

export const updatePaymentProvider = (
  id: string,
  data: Omit<PaymentProvider, 'id'>,
) => http.put<PaymentProvider[]>(`/operations/payment-providers/${id}`, data)

export const deletePaymentProvider = (id: string) =>
  http.delete<void>(`/operations/payment-providers/${id}`)
